import { Injectable } from "@angular/core";
import { Observable, ReplaySubject } from "rxjs";
import { IStepOption } from 'ngx-ui-tour-md-menu';

export interface TourStepsUpdate {
    steps: IStepOption[];
    stepDefaults?: IStepOption;
}

@Injectable({
    providedIn: 'root'
})
export class NgTourService {
    private steps$ = new ReplaySubject<TourStepsUpdate>(1);

    setTourSteps(steps: IStepOption[], stepDefaults?: IStepOption) {
        this.steps$.next({ steps, stepDefaults });
    }

    getTourSteps(): Observable<TourStepsUpdate> {
        return this.steps$.asObservable();
    }
}